export default __webpack_public_path__ + "static/media/ic_move.810b7936.svg";